import { JobStatus, PartImageIdentification } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';

export const PART_IMAGE_IDENTIFICATION_QUERY_KEY = 'partImageIdentification';

const POLL_INTERVAL_MS = 1500;

const isReadingCrop = (identification: PartImageIdentification): boolean =>
  identification.items.some(item => item.readingCrop);

const isFinished = (identification?: PartImageIdentification): boolean =>
  identification?.status === JobStatus.FAILED ||
  (identification?.status === JobStatus.COMPLETED && !isReadingCrop(identification));

export const useGetPartImageIdentification = (identificationId?: string) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  return useQuery<PartImageIdentification, AxiosApiError>({
    queryKey: [PART_IMAGE_IDENTIFICATION_QUERY_KEY, identificationId],
    queryFn: async () => {
      const response = await api.tenants.getPartImageIdentification(tenantId, identificationId ?? '');
      return response.data.partImageIdentification;
    },
    enabled: !!identificationId && !!tenantId,
    refetchInterval: query => (isFinished(query.state.data) ? false : POLL_INTERVAL_MS),
  });
};
